import { render, staticRenderFns } from "./DialogDeleteMessages.vue?vue&type=template&id=2e9867e6&scoped=true&"
import script from "./DialogDeleteMessages.vue?vue&type=script&lang=ts&"
export * from "./DialogDeleteMessages.vue?vue&type=script&lang=ts&"
import style0 from "./DialogDeleteMessages.vue?vue&type=style&index=0&id=2e9867e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9867e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VRow})
